export function getAttr(el, attr) {
  return el.getAttribute(attr);
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/getAttr.js